import {Component, inject, OnInit} from '@angular/core';
import {FormFieldComponent} from '../shared/components/form-field/form-field.component';
import {TituloRotinaComponent} from '../shared/components/app-titulo/titulo-component';
import {MatDialog} from '@angular/material/dialog';
import {
  ModalCadastroVisualizacaoPesquisaComponent
} from './modal-cadastro-visualizacao-pesquisa/modal-cadastro-visualizacao-pesquisa.component';
import {ValidacaoAlteracaoCampoService} from '../shared/service/utilitarios/validacao-alteracao-campo.service';
import {MsgService} from '../shared/service/msg.service';
import {ButtonPadraoComponent} from '../shared/components/button-padrao/button-padrao.component';
import {DatePipe, NgStyle} from '@angular/common';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatTooltip} from '@angular/material/tooltip';
import {FluxoService} from '../shared/service/fluxo-service';
import {FluxoBusca} from '../shared/model/fluxo/fluxo-busca-model';
import {TipoFluxoEnum} from '../shared/enum/tipo-fluxo.enum';
import {FluxoSalvarModel} from '../shared/model/fluxo/fluxo-salvar-model';
import {Router} from '@angular/router';
import {ModalConfirmacaoComponent} from '../shared/modais/modal-confirmacao/modal-confirmacao.component';

@Component({
  selector: 'app-pesquisa',
  standalone: true,
  imports: [
    FormFieldComponent,
    TituloRotinaComponent,
    ButtonPadraoComponent,
    DatePipe,
    MatTableModule,
    MatTooltip,
    NgStyle
  ],
  templateUrl: './pesquisa.component.html',
  styleUrl: './pesquisa.component.css'
})
export class PesquisaComponent implements OnInit {
  pesquisas: FluxoBusca[] = [];
  dataSource: MatTableDataSource<FluxoBusca> = new MatTableDataSource<FluxoBusca>();
  colunas: string[] = ['acao', 'id', 'titulo', 'status', 'statusPesquisa', 'descricao', 'usuarioCriacao', 'dataCriacao', 'usuarioAlteracao', 'dataAlteracao'];

  private readonly dialog = inject(MatDialog);
  private readonly alteracaoService = inject(ValidacaoAlteracaoCampoService);
  private readonly msgService = inject(MsgService);
  private readonly fluxoService = inject(FluxoService);
  private readonly router = inject(Router);

  ngOnInit() { this.buscarPesquisas(); }

  buscarPesquisas() {
    this.fluxoService.buscarPeloTipo([TipoFluxoEnum.PESQUISA]).subscribe({
      next: res => {
        this.pesquisas = res;
        this.dataSource = new MatTableDataSource<FluxoBusca>(this.pesquisas);
      }
    });
  }

  abrirModal(visualizar: boolean, pesquisa: FluxoSalvarModel = new FluxoSalvarModel()) {
    const dialogRef = this.dialog.open(ModalCadastroVisualizacaoPesquisaComponent, {
      width: '361px', height: '100vh',
      position: {
        top: '0',
        right: '0'
      },
      data: { visualizar, pesquisa: JSON.parse(JSON.stringify(pesquisa)) },
      panelClass: 'slide-modal',
      disableClose: !visualizar
    });

    if (!visualizar) {
      dialogRef.backdropClick().subscribe(() => {
        const podeFechar = !this.alteracaoService.isCamposAlteracao() ||
          window.confirm('Pode possuir alterações não salvas, deseja fechar?');
        if (podeFechar) { dialogRef.close(); }
      });
    }

    dialogRef.afterClosed().subscribe({
      next: res => {
        if (res) {
          this.fluxoService.salvar(res).subscribe({
            next: () => {
              this.msgService.msgSucesso('Sucesso ao salvar pesquisa.');
              this.buscarPesquisas();
            }
          });
        }
      }
    });
  }

  selecionarFluxo(fluxo: FluxoBusca) {
    this.router.navigate(['/pesquisa', fluxo.id]);
  }

  clonarFluxo(fluxo: FluxoBusca) {
    this.dialog.open(ModalConfirmacaoComponent, {
      data: { texto: 'Deseja gerar uma cópia do fluxo de pesquisa?' }
    }).afterClosed().subscribe({
      next: res => {
        if (res) {
          this.fluxoService.clonarFluxo(fluxo.id).subscribe({
            next: () => this.buscarPesquisas()
          });
        }
      }
    });
  }

  finalizarFluxo(fluxo: FluxoBusca) {
    this.dialog.open(ModalConfirmacaoComponent, {
      data: { texto: 'Deseja finalizar o fluxo de pesquisa?' }
    }).afterClosed().subscribe({
      next: res => {
        if (res) {
          this.fluxoService.alterarStatusPesquisaPeloFluxoId(fluxo.id, 'Finalizado').subscribe({
            next: () => this.buscarPesquisas()
          });
        }
      }
    });
  }
}
